import EfImg from '@elem/ui/ef-img';
import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import EfLink from '@elem/ui/ef-link';
import { LearnMoreList } from '../../common';
import css from './index.module.scss';

export default function F() {
    const { locale = 'uk' } = useRouter();

    const Data = useMemo(() => {
        const data = {
            title: '',
            dsec: '',
        };

        switch (locale) {
            case 'uk':
                data.title = 'Home Battery | Support and Services';
                data.dsec =
                    'Get professional support from our EcoFlow Home Battery experts, including online help, on-site services, warranty details and the latest updates.';
                break;
            case 'de':
                data.title = 'Heimbatterie | Support und Services';
                data.dsec =
                    'Erhalten Sie professionelle Unterstützung von unseren EcoFlow Heimbatterie-Experten, einschließlich Online-Hilfe, Vor-Ort-Service, Garantieinformationen und die neuesten Updates.';
                break;

            case 'eu':
                data.title = 'Home Battery | Support and Services';
                data.dsec =
                    'Get professional support from our EcoFlow Home Battery experts, including online help, on-site services, warranty details and the latest updates.';
                break;
            case 'nl':
                data.title = 'Thuisbatterij | Ondersteuning en service';
                data.dsec =
                    'Ontvang professionele ondersteuning van onze EcoFlow Home Battery-experts, inclusief online hulp, service op locatie, garantie-informatie en de nieuwste updates.';
                break;
        }

        return data;
    }, [locale]);

    return (
        <div className={`support-module ${css['Support']}`}>
            <EfSpec />
            <div className="F-container">
                <div className="F-container-info">
                    <div className="F-title">{Data.title}</div>
                    <div className="F-desc">{Data.dsec}</div>
                    <EfLink
                        className="F-link support-link"
                        href={`https://energy.ecoflow.com/${locale}/support`}
                        dataLayer={[
                            {
                                event: 'uaEvent',
                                event_name: 'get_support',
                                button_name: `${Data.title}_${LearnMoreList[locale]}`,
                            },
                        ]}
                    >
                        {`${LearnMoreList[locale] || LearnMoreList['us']} >`}
                    </EfLink>
                </div>
                <div>
                    <EfImg className="F-img" pc="https://websiteoss.ecoflow.com/upload/image/1731553807863/F.png" />
                </div>
            </div>
        </div>
    );
}
